import { debounce } from 'lodash';
import { useCallback, useEffect, useRef } from 'react';
import { useIsMounted } from './is-mounted';

export function useDebounce(cb, delay) {
  const options = {
    leading: false,
    trailing: true,
  };
  const inputsRef = useRef(cb);
  const isMounted = useIsMounted();
  useEffect(() => {
    inputsRef.current = { cb, delay };
  });

  return useCallback(
    debounce(
      (...args) => {
        if (inputsRef.current.delay === delay && isMounted()) {
          inputsRef.current.cb(...args);
        }
      },
      delay,
      options
    ),
    [delay, debounce]
  );
}
